export default "__VITE_ASSET__XEYLeCXj__"